import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {ComputedTranche} from '../../../components/dex/dex-streaming/types/computed/computed-tranche';
import {SelectInputModule} from '../../../components/select-input';
import {SelectItem} from '../../../components/select-input/select-item';
import {DexTrancheComposBarComponent} from './dex-tranche-compos-bar/dex-tranche-compos-bar.component';
import {DexTrancheComposTableComponent} from './dex-tranche-compos-table/dex-tranche-compos-table.component';

const DEX_TRANCHE_COMPOS_SELECT_ITEMS: Array<SelectItem<string>> = [
    {
        label: '30D Balance',
        value: '30D'
    },
    {
        label: '7D Balance',
        value: '7D'
    },
    {
        label: '1D Balance',
        value: '1D'
    }
];

@Component({
    selector:        'dex-tranche-compos',
    templateUrl:     './dex-tranche-compos.component.html',
    styleUrl:        './dex-tranche-compos.component.scss',
    imports: [
        DexTrancheComposBarComponent,
        DexTrancheComposTableComponent,
        SelectInputModule,
        ReactiveFormsModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DexTrancheComposComponent {

    public readonly tranche = input.required<ComputedTranche>();

    public readonly selectItems = DEX_TRANCHE_COMPOS_SELECT_ITEMS;

    public readonly selectFormControl = new FormControl<string>(this.selectItems[0].value);

}
